import React, { useState, useEffect, useRef } from "react";
import { menuItems } from "../../../../landing/data";
import SiteLogo from "../../../SiteLogo";
import { Link } from "react-router-dom";

const MobileHeader = () => {
  const [isNavActive, setIsNavActive] = useState(false);
  const navRef = useRef(null);
  const overlayRef = useRef(null);

  const toggleNav = () => {
    setIsNavActive((prev) => !prev);
  };

  useEffect(() => {
    const handleOverlayClick = () => {
      setIsNavActive(false);
    };

    if (overlayRef.current) {
      overlayRef.current.addEventListener("click", handleOverlayClick);
    }

    return () => {
      if (overlayRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        overlayRef.current.removeEventListener("click", handleOverlayClick);
      }
    };
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      setIsNavActive(false);
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <header className="relative flex flex-col xl:hidden">
      <div className="h-24 bg-white flex items-center justify-between fixed top-0 left-0 z-50 w-full px-4 py-3">
        <SiteLogo />
        <button
          aria-label="mobile-Menu"
          className="w-6 h-6 text-main-black text-48 toggle_nav_menu mr-3"
          id="mobile_nav_toggle_menu"
          onClick={toggleNav}
        >
          <svg
            className={`transition-all duration-300 pointer-events-none ${
              isNavActive ? "hidden" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32-14.3 32 32z" />
          </svg>
          <svg
            className={`transition-all duration-300 pointer-events-none ${
              isNavActive ? "" : "hidden"
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 512"
          >
            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
          </svg>
        </button>
      </div>
      <div className="transition-all duration-300">
        <div
          className={`fixed z-40 w-full h-screen transition-all duration-300 delay-150 bg-black/80 ${
            isNavActive ? "left-0" : "-left-full"
          }`}
          id="mobile-nav-div-overlay"
          ref={overlayRef}
        ></div>
        <div
          className={`fixed z-50 p-5 w-full h-screen overflow-y-scroll transition-all duration-300 bg-white top-24 ${
            isNavActive ? "left-0" : "-left-full"
          }`}
          id="mobile-nav-div"
          ref={navRef}
        >
          <div className="flex flex-col pt-5 pl-5 gap-28">
            <ul className="flex flex-col gap-5 text-base font-medium leading-5 text-paragraph font-inter">
              {menuItems.map((menuItem, index) => (
                <li key={index} className="">
                  <a
                    className="relative home-two-nav-item w-fit"
                    href={menuItem.link}
                  >
                    {menuItem.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col gap-5 mt-5">
            <Link to="https://portal.bpay.rw/" target="_blank">
              <div className="home-two-btn-white-rev home-two-btn-white-rev-sm group bg-blue-sass border-blue-sass">
                <span className="relative z-10 text-base font-semibold text-white transition-all duration-300 group-hover:text-blue-sass font-inter">
                  Bike Owner Portal
                </span>
                <svg
                  className="relative z-10"
                  width="7"
                  height="12"
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="transition-all duration-300 group-hover:stroke-blue-sass stroke-white"
                    d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default MobileHeader;
